import React, { useEffect, useState } from 'react';
import '../styles.css';
import { useSelector, useDispatch } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { HIDDEN, SHOW, FADE, HIDE, MODE_SOLO, MODE_AI } from '../../HOME/const';
import { delay, dbget, dbset } from '../../HOME/utils';
import { GradientBackground } from '../COMPONENTS/Background';
import Toolbar from '../COMPONENTS/Toolbar';
import Scoreboard from '../COMPONENTS/Scoreboard';
import Board from '../COMPONENTS/Board';
import Options from '../COMPONENTS/Options';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { REQUEST_RESET_STATS_OFF, REQUEST_SURRENDER_OFF } from '../../HOME/REDUX/actions';
import { UNREPORT_INVALID_ACTION } from '../REDUX/actions';
import { SEEN_SOLO_OPTIONS_KEY, SEEN_AI_OPTIONS_KEY, SEEN_FRIEND_OPTIONS_KEY } from '../../PN/const';

const GamePage = () => {
  const [_dummy, setDummy] = useState(false);
  const [options, setOptions] = useState(HIDDEN);
  const dispatch = useDispatch();
  const { showLeaders } = useSelector(state => state.common);
  const { mode } = useSelector(state => state.pn);

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  useEffect(() => {
    const forceUpdate = () => setDummy(!_dummy);
    window.addEventListener('resize', forceUpdate);

    const key = mode === MODE_SOLO ? SEEN_SOLO_OPTIONS_KEY : mode === MODE_AI ? SEEN_AI_OPTIONS_KEY : SEEN_FRIEND_OPTIONS_KEY;

    dbget(key, seen => {
      if (!seen) {
        setOptions(SHOW);
        dbset(key, true);
      }
    });

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [_dummy, dispatch]);

  const handleOptions = e => {
    dispatch(REQUEST_RESET_STATS_OFF);
    dispatch(REQUEST_SURRENDER_OFF);
    dispatch(UNREPORT_INVALID_ACTION);

    if (options === SHOW) {
      hideOptions();
    } else if (options === HIDDEN) {
      setOptions(SHOW);
    }
  };

  const hideOptions = e => {
    if (options === SHOW) {
      setOptions(FADE);
      delay(() => setOptions(HIDDEN));
    }
  };

  const handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      hideOptions();
    }
  };

  return (
    <div className="page-root">
      <div className="pn-page ta-game-page" style={{ backgroundImage: GradientBackground }} onClick={handleClick}>
        <Scoreboard hideOptions={hideOptions} />
        <Board />
        {showLeaders === HIDE ? null : <Leaderboard />}
      </div>
      <Options op={options} hideOptions={hideOptions} />
      <Toolbar onClickOptions={handleOptions} hideOptions={hideOptions} />
      {showLeaders === HIDE ? (
        <>
          <BackButton />
          <HomeButton />
        </>
      ) : null}
    </div>
  );
};

export default GamePage;
